import {
  SET_GROUP_METADATA,
  SET_GROUP_METADATA_IS_LOADING,
} from '../constants/groupMetaDataConstants';

export const groupMetaDataInitialState = {
  groupDetailsList: [],
  listingRedirection: false,
  isLoading: true,
};

const groupMetadataReducer = (state = groupMetaDataInitialState, action) => {
  switch (action.type) {
    case SET_GROUP_METADATA:
      return {
        ...state,
        ...action.payload,
      };
    case SET_GROUP_METADATA_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
};

export default groupMetadataReducer;
